import { ReactNode, useState } from 'react';
import { Box, Typography } from '@mui/material';
import Parser from 'html-react-parser';

import { sendDatadogRumError } from 'utils/analytics/datadogRum';
import Dialog from 'modules/common/components/MUI/Dialog';

type ConfirmationModalProps = {
    title: string;
    message: ReactNode | string;
    callback: () => void | Promise<void>;
    trigger: React.ReactNode;
    yesText?: string;
    noText?: string;
};

function ConfirmationModal({
    title,
    message,
    callback,
    trigger,
    yesText = 'Yes',
    noText = 'No',
}: ConfirmationModalProps) {
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleClose = () => setOpen(false);

    const handleConfirm = async () => {
        if (loading) {
            return;
        }
        setLoading(true);
        try {
            await callback();
            handleClose();
        } catch (err) {
            sendDatadogRumError(
                'ConfirmationModal callback error',
                err instanceof Error ? err : new Error('ConfirmationModal callback failed')
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Box onClick={() => setOpen(true)} sx={{ display: 'inline-block' }}>
                {trigger}
            </Box>
            <Dialog
                open={open}
                onClose={loading ? undefined : handleClose}
                maxWidth="md"
                fullWidth
                heading={title}
                negativeAction={{
                    onClick: handleClose,
                    label: noText,
                    testId: 'no-button',
                    disabled: loading,
                }}
                positiveAction={{
                    onClick: handleConfirm,
                    label: yesText,
                    testId: 'yes-button',
                    loading,
                }}>
                {typeof message === 'string' ? <Typography>{Parser(message)}</Typography> : message}
            </Dialog>
        </>
    );
}
export default ConfirmationModal;
